import React from 'react';

/* istanbul ignore next */
function isIEBrowser() {
  const userAgent = window.navigator && window.navigator.userAgent;
  const isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1;
  const isEdge = userAgent.indexOf('Edge') > -1;
  const isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;

  return isIE || isEdge || isIE11;
}

function isTextOverflow(element) {
  // this is a workaround to fix the issue with IE scrollWidth
  // which the scrollWidth is off by 1px compared to the offsetWidth
  /* istanbul ignore next */
  const clientWidth = isIEBrowser() ? element.clientWidth + 1 : element.clientWidth;

  return clientWidth < element.scrollWidth;
}

export const withOverflowProp
  = WrappedComponent => class WithOverflowProp extends React.Component {
    constructor(props) {
      super(props);

      // TODO: React Router still supports React 16.3.2. So we are not able to use
      // `forwardRef` right now. The fix will be in version 5 when React Router upgrade
      // their dependency to React 16.7+. Check and change to use forwardRef until then.
      this.forwardedRef = React.createRef();

      this.state = {
        overflow: false,
      };
    }

    componentDidMount() {
      this.checkOverflow();
    }

    componentDidUpdate() {
      this.checkOverflow();
    }

    checkOverflow = () => {
      const element = this.forwardedRef.current;

      const overflow = isTextOverflow(element);
      if (overflow !== this.state.overflow) {
        this.setState({ overflow });
      }
    }

    render = () => (<WrappedComponent
      forwardedRef={this.forwardedRef}
      isTextOverflow={this.state.overflow}
      {...this.props}
    />)
  };
